<template>
  <VPopup
    :visible="true"
    class="popup-menu"
  >
    <slot name="additional" />

    <VButton
      @click="addPosition"
    >
      <template #icon>
        <VIcon
          material="add"
          theme="outlined"
        />
      </template>
      Добавить позицию
    </VButton>

    <VButton
      v-for="plan in plans"
      :key="plan.id"
      :title="`История изменений плана на площадке ${plan.site}`"
      @click="showHistory(plan)"
    >
      <template #icon>
        <VIcon
          material="history"
          theme="outlined"
        />
      </template>
      {{ plan.site }}
    </VButton>
  </VPopup>
</template>

<script>

export default {
	name:  'ProductionPlansGridPopupMenu',
	props: {
		plans: {
			type: Array,
		}
	},
	methods: {
		addPosition() {
			this.$emit('add-position');
		},
		showHistory(plan) {
			this.$emit('show-history', plan);
		}
	},
};
</script>
